import api from "./api";

// Obtener todas las categorías (realmente obtiene departamentos con su árbol)
export const getCategorias = async () => {
  const url = `/`
  try {
    const response = await api.get(url + 'departamentos');
    return response.data;
  } catch (error) {
    console.error("Error al obtener categorías", error);
    return { data: [] };
  }
};

export const createItem = async (level: 'departamento' | 'categoria' | 'subcategoria', data: any, parent?: any) => {
  let url = `/`;
  const dataToPost = {
    ...data
  }
  switch (level) {
    case 'departamento':
      url += 'departamentos';
      break;
    case 'categoria':
      url += 'categorias';
      dataToPost.departamento_id = parent.id
      break;
    case 'subcategoria':
      url += 'subcategorias';
      dataToPost.categoria_id = parent.id
      break;
    default:
      throw new Error('Nivel no válido');
  }

  try {
    const response = await api.post(url, dataToPost);
    return response.data;
  } catch (error) {
    console.error("Error al crear categoría", error);
  }
};

// Actualizar una categoría
export const updateCategoria = async (level: 'departamento' | 'categoria' | 'subcategoria', data: any, parent: any, id: number) => {
  let url = `/`;
  const dataToPost = {
    ...data
  }
  switch (level) {
    case 'departamento':
      url += 'departamentos';
      break;
    case 'categoria':
      url += 'categorias';
      break;
    case 'subcategoria':
      url += 'subcategorias';
      break;
    default:
      throw new Error('Nivel no válido');
  }
  try {
    const response = await api.put(`${url}/${id}`, dataToPost);
    return response.data;
  } catch (error) {
    console.error("Error al actualizar categoría", error);
  }
};

// Eliminar una categoría
export const deleteCategoria = async (level: 'departamento' | 'categoria' | 'subcategoria', id: number) => {
  try {
    let url = `/`;

    switch (level) {
      case 'departamento':
        url += 'departamentos';
        break;
      case 'categoria':
        url += 'categorias';
        break;
      case 'subcategoria':
        url += 'subcategorias';
        break;
      default:
        throw new Error('Nivel no válido');
    }
    await api.delete(`${url}/${id}`);
  } catch (error) {
    console.error("Error al eliminar categoría", error);
  }
};
